var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-16415393"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "box itemDetailPanel pt-3 pb-3 pl-5 pr-5"
};
const _hoisted_2 = { class: "media" };
const _hoisted_3 = { class: "media-content" };
const _hoisted_4 = { class: "content" };
const _hoisted_5 = { class: "level is-mobile" };
const _hoisted_6 = { class: "mt-2" };
const _hoisted_7 = {
    key: 0,
    class: "tag is-primary is-rounded has-text-weight-bold ml-3"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-share mr-2" }, null, -1));
const _hoisted_9 = {
    key: 1,
    class: "tag is-danger is-rounded has-text-weight-bold ml-3"
};
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1));
const _hoisted_11 = { class: "level is-mobile" };
const _hoisted_12 = { class: "buttonRow level-left" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1));
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-share mr-2" }, null, -1));
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-tag mr-2" }, null, -1));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-link mr-2" }, null, -1));
const _hoisted_17 = { class: "tag is-light is-rounded has-text-weight-bold" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-external-link-alt mr-2" }, null, -1));
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", null, "Preview", -1));
const _hoisted_20 = { key: 0 };
const _hoisted_21 = { key: 1 };
const _hoisted_22 = ["src"];
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-eye mr-3" }, null, -1));
const _hoisted_24 = {
    key: 3,
    class: "button is-link is-disabled",
    style: { "opacity": "0.5" }
};
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-eye mr-3" }, null, -1));
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, " Do you wish to shred / destroy this inbound mail item? ")
], -1));
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, "This will result in the item being physically destroyed.", -1));
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, "This should generally only be done for junk mail.", -1));
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, " Do you wish to forward this inbound mail item? ")
], -1));
const _hoisted_31 = { class: "pt-5" };
const _hoisted_32 = { class: "columns p-3" };
const _hoisted_33 = { class: "columns" };
const _hoisted_34 = { class: "columns" };
const _hoisted_35 = { class: "columns" };
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, "Please ensure the correct address is specified.", -1));
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "pt-2" }, "We cannot recover items forwarded to the wrong address.", -1));
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, " Do you wish to apply a label to this inbound mail item? ")
], -1));
const _hoisted_39 = { class: "pt-5" };
const _hoisted_40 = { class: "columns" };
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, " Do you wish to link this inbound mail item to a citizen / application? ")
], -1));
const _hoisted_42 = { class: "pt-5" };
const _hoisted_43 = { class: "columns p-3" };
const _hoisted_44 = {
    key: 0,
    class: "ml-3 mt-2"
};
const _hoisted_45 = {
    key: 0,
    class: "mt-3"
};
const _hoisted_46 = { class: "columns" };
const _hoisted_47 = {
    key: 0,
    class: "columns"
};
const _hoisted_48 = {
    key: 1,
    class: "columns"
};
import { doApiAction } from "@/core/api";
import { enumKey, formatDateShort, formatDateTime, notifyError } from "@/core/utils";
import { computed, onMounted, reactive, ref, watch } from "vue";
import { apiInboundMail } from "./api";
import { Core, ProfileTypes } from "@minicity/core";
import { InboundMailItemStatus } from "./model";
import FormSelectField from "@/components/FormSelectField.vue";
import FormCheckboxField from "@/components/FormCheckboxField.vue";
import TypeAheadWithQuery from "@/components/TypeAheadWithQuery.vue";
import { apiCitizens } from "../citizens/api";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { requestStatusLabels } from "../applications/model";
import FormTextField from "@/components/FormTextField.vue";
import { sessionState } from "@/core/session";
import { useAsync } from "@/composables/useAsync";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InboundMailItemDetailPanel',
    props: {
        item: {},
        highlighted: { type: Boolean },
        showEntityLink: { type: Boolean }
    },
    emits: ['itemUpdated'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // We need to copy the item prop, as we cannot mutate props
        const itemCopy = ref(null);
        const previewImage = ref(null);
        onMounted(() => {
            itemCopy.value = Object.assign({}, props.item);
            itemLabel.value = props.item.label || "";
            apiInboundMail.getPreviewImage(props.item.id)
                .then(i => {
                previewImage.value = i;
            });
        });
        // Event for two-way binding
        const emit = __emit;
        const onItemChanged = (updatedItem) => {
            itemCopy.value = Object.assign({}, updatedItem);
            itemLabel.value = props.item.label || "";
            pendingAction.value = null;
            emit('itemUpdated', itemCopy.value);
        };
        const pendingAction = ref(null);
        const inProgressAction = ref(null);
        const entityLink = computed(() => {
            var _a, _b, _c, _d, _e;
            switch ((_a = itemCopy.value) === null || _a === void 0 ? void 0 : _a.entityType) {
                case Core.EntityType['Citizen']: return `/citizens/${(_b = itemCopy.value) === null || _b === void 0 ? void 0 : _b.entityId}`;
                case Core.EntityType['Birth Record']: return `/birthRecords/${(_c = itemCopy.value) === null || _c === void 0 ? void 0 : _c.entityId}`;
                case Core.EntityType['Georgia DFCS Benefits']: return `/georgiaBenefits/${(_d = itemCopy.value) === null || _d === void 0 ? void 0 : _d.entityId}`;
                case Core.EntityType['Social Security']: return `/socialSecurity/${(_e = itemCopy.value) === null || _e === void 0 ? void 0 : _e.entityId}`;
                default: return null;
            }
        });
        const downloadPdf = () => {
            doApiAction(inProgressAction, "downloadPdf", null, "Failed to download PDF", () => __awaiter(this, void 0, void 0, function* () {
                yield apiInboundMail.getPdfViewLink(itemCopy.value.id)
                    .then((link) => window.open(link));
            }));
        };
        const addComment = (message, attachments, notifyCaseworker) => __awaiter(this, void 0, void 0, function* () {
            return yield apiInboundMail.addComment(itemCopy.value.id, message, attachments, notifyCaseworker);
        });
        /*
         * Trashing
         */
        const trashItem = () => __awaiter(this, void 0, void 0, function* () {
            doApiAction(inProgressAction, "trashItem", null, "Failed to shred / destroy item", () => __awaiter(this, void 0, void 0, function* () {
                yield apiInboundMail.trashItem(itemCopy.value.id)
                    .then(updatedItem => onItemChanged(updatedItem));
            }));
        });
        /*
         * Forwarding
         */
        const forwardingRecipientId = ref(null);
        const forwardingAddress = reactive({
            number: "",
            street: "",
            city: "Atlanta",
            state: ProfileTypes.State["GA - Georgia"],
            postalCode: "",
            country: "US"
        });
        const knownForwardingRecipients = useAsync();
        onMounted(() => {
            if (sessionState.session) {
                knownForwardingRecipients.fetch(apiInboundMail.getForwardingRecipients(), "Failed to load forwarding recipients");
            }
        });
        const searchForForwardingRecipient = (query) => __awaiter(this, void 0, void 0, function* () {
            if (knownForwardingRecipients.status !== "ready")
                return [];
            const queryParts = query.trim().toLowerCase().split(" ").filter(part => part.length > 0);
            if (queryParts.length == 0)
                return [];
            const results = [];
            for (const entry of knownForwardingRecipients.data) {
                const key = entry.recipient.name.toLowerCase() + " " + ProfileTypes.formatUSAddressShort(entry.recipient.address).toLowerCase();
                let matches = true;
                for (const queryPart of queryParts) {
                    if (!key.includes(queryPart)) {
                        matches = false;
                        break;
                    }
                }
                if (matches) {
                    results.push(entry);
                }
            }
            return results;
        });
        const onForwardingRecipientSelected = (entry) => __awaiter(this, void 0, void 0, function* () {
            forwardingRecipientId.value = entry.id;
            forwardingAddress.number = entry.recipient.address.number;
            forwardingAddress.street = entry.recipient.address.street;
            forwardingAddress.city = entry.recipient.address.city;
            forwardingAddress.state = entry.recipient.address.state;
            forwardingAddress.postalCode = entry.recipient.address.postalCode;
            forwardingAddress.country = entry.recipient.address.country;
        });
        const forwardItem = () => __awaiter(this, void 0, void 0, function* () {
            if (forwardingRecipientId.value == null) {
                notifyError("Please select a recipient");
                return;
            }
            doApiAction(inProgressAction, "forwardItem", null, "Failed to forward item", () => __awaiter(this, void 0, void 0, function* () {
                yield apiInboundMail.forwardItem(itemCopy.value.id, forwardingRecipientId.value)
                    .then(updatedItem => onItemChanged(updatedItem));
            }));
        });
        /*
         * Labelling
         */
        const itemLabel = ref("");
        const labelItem = () => __awaiter(this, void 0, void 0, function* () {
            doApiAction(inProgressAction, "labelItem", null, "Failed to label item", () => __awaiter(this, void 0, void 0, function* () {
                yield apiInboundMail.labelItem(itemCopy.value.id, itemLabel.value)
                    .then(updatedItem => onItemChanged(updatedItem));
            }));
        });
        /*
         * Assignment
         */
        const searchForCitizens = (query) => __awaiter(this, void 0, void 0, function* () {
            return apiCitizens.searchForNetwork(query);
        });
        const citizenForAssignment = ref(null);
        const linkOptions = ref(null);
        const selectedLinkOption = ref(null);
        const linkIsFinal = ref(false);
        const linkNote = ref("");
        const onCitizenSelected = (e) => __awaiter(this, void 0, void 0, function* () {
            citizenForAssignment.value = e;
            const citizenId = citizenForAssignment.value.id;
            linkOptions.value = null;
            selectedLinkOption.value = null;
            const citizenDetail = yield apiCitizens.get(citizenForAssignment.value.id);
            const citizenLinkOptions = {};
            for (const application of citizenDetail.activeApplications) {
                switch (application.type) {
                    case Core.EntityType["Birth Record"]:
                        citizenLinkOptions[`Birth Record Application #${application.id} - Created ${formatDateShort(application.createdAt)} - ${requestStatusLabels[application.status]}`] = {
                            category: "birth_record", keyDocumentType: "BIRTH_RECORD",
                            entityType: application.type, entityId: application.id,
                            defaultNote: "A new document has been received relating to this citizen's birth record application"
                        };
                        break;
                    case Core.EntityType["Georgia DFCS Benefits"]:
                        citizenLinkOptions[`Georgia DFCS Benefits Application #${application.id} - Created ${formatDateShort(application.createdAt)} - ${requestStatusLabels[application.status]}`] = {
                            category: "georgia_benefits", keyDocumentType: "GEORGIA_DFCS_BENEFITS",
                            entityType: application.type, entityId: application.id,
                            defaultNote: "A new document has been received relating to this citizen's benefits application"
                        };
                        break;
                    case Core.EntityType["Social Security"]:
                    case Core.EntityType["Online Social Security"]:
                        citizenLinkOptions[`Social Security Application #${application.id} - Created ${formatDateShort(application.createdAt)} - ${requestStatusLabels[application.status]}`] = {
                            category: "social_security", keyDocumentType: "SOCIAL_SECURITY",
                            entityType: Core.EntityType["Social Security"], entityId: application.id,
                            defaultNote: "A new document has been received relating to this citizen's Social Security card application"
                        };
                        break;
                }
            }
            citizenLinkOptions["State ID Application"] = {
                category: "state_id", keyDocumentType: "STATE_ID",
                entityType: Core.EntityType.Citizen, entityId: citizenId,
                defaultNote: "A new document has been received relating to this citizen's state ID application"
            };
            citizenLinkOptions["Veteran ID Application"] = {
                category: "veteran_id", keyDocumentType: "VETERAN_ID",
                entityType: Core.EntityType.Citizen, entityId: citizenId,
                defaultNote: "A new document has been received relating to this citizen's veteran ID application"
            };
            citizenLinkOptions["Other (link to citizen directly)"] = {
                category: "citizen",
                entityType: Core.EntityType.Citizen, entityId: citizenId,
                defaultNote: props.item.label ? `A new document has been received: ${props.item.label}.` : 'A new document has been received relating to this citizen.'
            };
            linkOptions.value = citizenLinkOptions;
            linkNote.value = "";
        });
        watch([selectedLinkOption], () => {
            if (!selectedLinkOption.value)
                return;
            linkNote.value = selectedLinkOption.value.defaultNote;
        });
        const linkItem = () => __awaiter(this, void 0, void 0, function* () {
            if (!selectedLinkOption.value) {
                notifyError("Please specify the citizen / application this item should be linked to");
                return;
            }
            const linkOption = selectedLinkOption.value;
            doApiAction(inProgressAction, "linkItem", null, "Failed to link item", () => __awaiter(this, void 0, void 0, function* () {
                yield apiInboundMail.linkItemToEntity(itemCopy.value.id, linkOption.entityType, linkOption.entityId, linkNote.value, linkIsFinal.value ? linkOption.keyDocumentType : undefined)
                    .then(updatedItem => onItemChanged(updatedItem));
            }));
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_CommentSection = _resolveComponent("CommentSection");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (itemCopy.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("article", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("h2", _hoisted_6, [
                                                _createTextVNode(" #" + _toDisplayString(_ctx.item.id) + _toDisplayString(_ctx.item.label ? ` - ${_ctx.item.label}` : '') + " ", 1),
                                                (_ctx.item.status == _unref(InboundMailItemStatus).FORWARDED)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                                        _hoisted_8,
                                                        _createTextVNode("Forwarded ")
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (_ctx.item.status == _unref(InboundMailItemStatus).TRASHED)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                                        _hoisted_10,
                                                        _createTextVNode("Destroyed ")
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", null, "Received " + _toDisplayString(_unref(formatDateTime)(itemCopy.value.receivedAt)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("div", _hoisted_12, [
                                                (_ctx.item.status == _unref(InboundMailItemStatus).RECEIVED)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        type: "submit",
                                                        class: _normalizeClass(["formButton button is-info is-small", [{ 'is-loading': inProgressAction.value == 'changeStatus' }, 'mb-2']]),
                                                        onClick: _cache[0] || (_cache[0] = ($event) => (pendingAction.value = 'trashItem'))
                                                    }, [
                                                        _hoisted_13,
                                                        _createTextVNode("Shred / Destroy")
                                                    ], 2))
                                                    : _createCommentVNode("", true),
                                                (_ctx.item.status == _unref(InboundMailItemStatus).RECEIVED)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        type: "submit",
                                                        class: _normalizeClass(["formButton button is-info is-small", [{ 'is-loading': inProgressAction.value == 'changeStatus' }, 'mb-2']]),
                                                        onClick: _cache[1] || (_cache[1] = ($event) => (pendingAction.value = 'forwardItem'))
                                                    }, [
                                                        _hoisted_14,
                                                        _createTextVNode("Forward To Address")
                                                    ], 2))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    class: _normalizeClass(["formButton button is-info is-small", [{ 'is-loading': inProgressAction.value == 'changeStatus' }, 'mb-2']]),
                                                    onClick: _cache[2] || (_cache[2] = ($event) => (pendingAction.value = 'labelItem'))
                                                }, [
                                                    _hoisted_15,
                                                    _createTextVNode("Add Label / Description")
                                                ], 2),
                                                (!_ctx.item.entityType)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 2,
                                                        type: "submit",
                                                        class: _normalizeClass(["formButton button is-info is-small", [{ 'is-loading': inProgressAction.value == 'changeStatus' }, 'mb-2']]),
                                                        onClick: _cache[3] || (_cache[3] = ($event) => { pendingAction.value = 'linkItem'; citizenForAssignment.value = null; })
                                                    }, [
                                                        _hoisted_16,
                                                        _createTextVNode("Link to Citizen / Record")
                                                    ], 2))
                                                    : _createCommentVNode("", true),
                                                (entityLink.value)
                                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                                        key: 3,
                                                        to: `${entityLink.value}`,
                                                        target: "_blank",
                                                        class: "level-right"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("span", _hoisted_17, [
                                                                _hoisted_18,
                                                                _createTextVNode(" View " + _toDisplayString(_unref(enumKey)(itemCopy.value.entityType, _unref(Core).EntityType)) + " Page ", 1)
                                                            ])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["to"]))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", null, [
                                            _hoisted_19,
                                            (!previewImage.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Loading..."))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                    _createElementVNode("img", {
                                                        src: previewImage.value,
                                                        class: "previewImage"
                                                    }, null, 8, _hoisted_22)
                                                ])),
                                            (itemCopy.value.scannedAt)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 2,
                                                    class: "button is-link",
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (downloadPdf()))
                                                }, [
                                                    _hoisted_23,
                                                    _createTextVNode(" View Full PDF ")
                                                ]))
                                                : (_openBlock(), _createElementBlock("a", _hoisted_24, [
                                                    _hoisted_25,
                                                    _createTextVNode(" PDF not available - Item is not yet scanned ")
                                                ]))
                                        ]),
                                        _hoisted_26,
                                        _createVNode(_component_CommentSection, {
                                            getComments: () => _unref(apiInboundMail).getComments(itemCopy.value.id),
                                            addComment: addComment,
                                            getAttachmentViewLink: (commentId, attachmentId) => _unref(apiInboundMail).getCommentAttachmentViewLink(itemCopy.value.id, commentId, attachmentId),
                                            hideNotifyCaseworkerOption: ""
                                        }, null, 8, ["getComments", "getAttachmentViewLink"])
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (pendingAction.value == 'trashItem')
                    ? (_openBlock(), _createBlock(_component_ModalDialog, {
                        key: 1,
                        active: "",
                        title: "Shred / Destroy Item",
                        severity: "danger",
                        allowClose: true,
                        onClose: _cache[5] || (_cache[5] = ($event) => (pendingAction.value = null)),
                        firstButtonText: "Go Back",
                        firstButtonSeverity: "link",
                        onFirstbuttonselected: _cache[6] || (_cache[6] = ($event) => (pendingAction.value = null)),
                        secondButtonText: "Shred / Destroy Item",
                        secondButtonSeverity: "danger",
                        onSecondbuttonselected: _cache[7] || (_cache[7] = ($event) => (trashItem())),
                        loading: inProgressAction.value == 'trashItem'
                    }, {
                        default: _withCtx(() => [
                            _hoisted_27,
                            _hoisted_28,
                            _hoisted_29
                        ]),
                        _: 1
                    }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                (pendingAction.value == 'forwardItem')
                    ? (_openBlock(), _createBlock(_component_ModalDialog, {
                        key: 2,
                        active: "",
                        title: "Forward Item",
                        severity: "info",
                        allowClose: true,
                        onClose: _cache[15] || (_cache[15] = ($event) => (pendingAction.value = null)),
                        firstButtonText: "Go Back",
                        firstButtonSeverity: "link",
                        onFirstbuttonselected: _cache[16] || (_cache[16] = ($event) => (pendingAction.value = null)),
                        secondButtonText: "Forward Item",
                        secondButtonSeverity: "danger",
                        onSecondbuttonselected: _cache[17] || (_cache[17] = ($event) => (forwardItem())),
                        loading: inProgressAction.value == 'forwardItem'
                    }, {
                        default: _withCtx(() => [
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                    _createVNode(TypeAheadWithQuery, {
                                        getMatches: searchForForwardingRecipient,
                                        limit: 6,
                                        getLabel: (entry) => `${entry.recipient.name} - ${_unref(ProfileTypes).formatUSAddressShort(entry.recipient.address)}`,
                                        onItemSelected: _cache[8] || (_cache[8] = ($event) => (onForwardingRecipientSelected($event))),
                                        placeholder: "Type to find recipient...",
                                        icon: "fas fa-home"
                                    }, null, 8, ["getLabel"])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                    _createVNode(FormTextField, {
                                        label: "Building Number",
                                        modelValue: forwardingAddress.number,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((forwardingAddress.number) = $event)),
                                        isDisabled: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(FormTextField, {
                                        label: "Street",
                                        modelValue: forwardingAddress.street,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((forwardingAddress.street) = $event)),
                                        isDisabled: ""
                                    }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                    _createVNode(FormTextField, {
                                        label: "City",
                                        modelValue: forwardingAddress.city,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((forwardingAddress.city) = $event)),
                                        isDisabled: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(FormSelectField, {
                                        label: "State",
                                        modelValue: forwardingAddress.state,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((forwardingAddress.state) = $event)),
                                        options: _unref(ProfileTypes).StateNotUnknown,
                                        isDisabled: ""
                                    }, null, 8, ["modelValue", "options"])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                    _createVNode(FormTextField, {
                                        label: "Postal Code",
                                        modelValue: forwardingAddress.postalCode,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((forwardingAddress.postalCode) = $event)),
                                        numeric: "",
                                        length: 9,
                                        isDisabled: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(FormTextField, {
                                        label: "Country",
                                        modelValue: forwardingAddress.country,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((forwardingAddress.country) = $event)),
                                        isDisabled: ""
                                    }, null, 8, ["modelValue"])
                                ])
                            ]),
                            _hoisted_36,
                            _hoisted_37
                        ]),
                        _: 1
                    }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                (pendingAction.value == 'labelItem')
                    ? (_openBlock(), _createBlock(_component_ModalDialog, {
                        key: 3,
                        active: "",
                        title: "Label Item",
                        severity: "info",
                        allowClose: true,
                        onClose: _cache[19] || (_cache[19] = ($event) => (pendingAction.value = null)),
                        firstButtonText: "Go Back",
                        firstButtonSeverity: "link",
                        onFirstbuttonselected: _cache[20] || (_cache[20] = ($event) => (pendingAction.value = null)),
                        secondButtonText: "Label Item",
                        secondButtonSeverity: "info",
                        onSecondbuttonselected: _cache[21] || (_cache[21] = ($event) => (labelItem())),
                        loading: inProgressAction.value == 'labelItem'
                    }, {
                        default: _withCtx(() => [
                            _hoisted_38,
                            _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                    _createVNode(FormTextField, {
                                        label: "Label",
                                        modelValue: itemLabel.value,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((itemLabel).value = $event))
                                    }, null, 8, ["modelValue"])
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                (pendingAction.value == 'linkItem')
                    ? (_openBlock(), _createBlock(_component_ModalDialog, {
                        key: 4,
                        active: "",
                        title: "Link Item",
                        severity: "info",
                        allowClose: true,
                        onClose: _cache[26] || (_cache[26] = ($event) => (pendingAction.value = null)),
                        firstButtonText: "Go Back",
                        firstButtonSeverity: "link",
                        onFirstbuttonselected: _cache[27] || (_cache[27] = ($event) => (pendingAction.value = null)),
                        secondButtonText: "Link Item",
                        secondButtonSeverity: "info",
                        onSecondbuttonselected: _cache[28] || (_cache[28] = ($event) => (linkItem())),
                        loading: inProgressAction.value == 'linkItem'
                    }, {
                        default: _withCtx(() => [
                            _hoisted_41,
                            _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, [
                                    _createVNode(TypeAheadWithQuery, {
                                        getMatches: searchForCitizens,
                                        limit: 6,
                                        getLabel: (cit) => `#${cit.id} - ${cit.displayName} (${cit.assignedCareProvider.name})`,
                                        onItemSelected: _cache[22] || (_cache[22] = ($event) => (onCitizenSelected($event))),
                                        placeholder: "Type to find citizen...",
                                        icon: "fas fa-user"
                                    }, null, 8, ["getLabel"]),
                                    (citizenForAssignment.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            _createElementVNode("strong", null, _toDisplayString(citizenForAssignment.value.displayName), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                (citizenForAssignment.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                        _createElementVNode("div", _hoisted_46, [
                                            (linkOptions.value === null)
                                                ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
                                                : (_openBlock(), _createBlock(FormSelectField, {
                                                    key: 1,
                                                    label: "Link To",
                                                    modelValue: selectedLinkOption.value,
                                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((selectedLinkOption).value = $event)),
                                                    options: linkOptions.value
                                                }, null, 8, ["modelValue", "options"]))
                                        ]),
                                        (selectedLinkOption.value && selectedLinkOption.value.keyDocumentType)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                _createVNode(FormCheckboxField, {
                                                    boxLabel: "This mail item contains the citizen's final, approved application / key document",
                                                    modelValue: linkIsFinal.value,
                                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((linkIsFinal).value = $event))
                                                }, null, 8, ["modelValue"])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (selectedLinkOption.value && (!selectedLinkOption.value.keyDocumentType || !linkIsFinal.value))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                _createVNode(FormTextField, {
                                                    label: "Note to include with document",
                                                    modelValue: linkNote.value,
                                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((linkNote).value = $event))
                                                }, null, 8, ["modelValue"])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 1
                    }, 8, ["loading"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
